/**
 * Created by Mark on 04/05/2017.
 */



import React   from 'react';

import {ProgressBar, Row, Col , Card , Button , Badge} from 'react-bootstrap';
import Profile from '../../../components/profile/homework-profile';
import AboutPanel from '../../../components/profile/profile-tabs/new_homework/about-panel.js';
import AssignmentService from '../../../services/assignments-service';
import ScoresAndReports from '../../../components/profile/profile-tabs/new_homework/scores-panel.js';
import VocabPanel from '../../../components/profile/profile-tabs/new_homework/vocabs-panel';
import CustomPanel from '../../../components/profile/profile-tabs/new_homework/custom-panel';
import SentencePanel from '../../../components/profile/profile-tabs/new_homework/sentence-panel';
import VerbPanel from '../../../components/profile/profile-tabs/new_homework/verb-panel';
import GrammarPanel from '../../../components/profile/profile-tabs/new_homework/grammar-panel';
import ExamPanel from '../../../components/profile/profile-tabs/new_homework/exam-panel';
import TaskNames from '../../../components/TaskNamesList.js';
import DateFormat from '../../../classes/date.js';
import UserService from '../../../services/user-service';
import UserStore from '../../../store/user-store';
import Constants from '../../../constants.js';
import Comfirmation from '../../popup/comfirmation_popup.js';

import Translation from '../../../store/internationalization-store.js';

export default class HomeworkOverview extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            homework:{'name':"homework name"},
            hasLoaded:false
        }
        this.steps = [AboutPanel];
    }

    getCurriculum(){
        let curriculums = Object.keys(this.curriculums).map(function(k) { return this.curriculums[k] }.bind(this));
        return curriculums[0]
    }

    componentDidMount(){
        UserService.getAssignments();
        UserService.getArchivedAssignments();
    }

    componentWillMount(){

        var homeworks = UserStore.archived;
        for(var key in homeworks) {
            if(!homeworks.hasOwnProperty(key)) {
                continue;
            } else if (homeworks[key].id == this.props.homeworkID) {
                this.setState({homework:homeworks[key], hasLoaded:true})
                break;
            }
        }

        var homeworks = UserStore.assignments;
        for(var key in homeworks) {
            if(!homeworks.hasOwnProperty(key)) continue;
            if(homeworks[key].id == this.props.homeworkID)
            {
                this.setState({homework:homeworks[key], hasLoaded:true})
                break;
            }
        }

        UserStore.on(Constants.GET_MY_ASSIGNMENTS, function() {
            var homeworks = UserStore.assignments;
            for(var key in homeworks) {
                if(!homeworks.hasOwnProperty(key)) continue;
                if(homeworks[key].id == this.props.homeworkID)
                {
                    this.setState({homework:homeworks[key], hasLoaded:true})
                    break;
                }

            }
        }.bind(this));

        UserStore.on(Constants.GET_MY_ARCHIVED_ASSIGNMENTS , () => {
            var homeworks = UserStore.archived;
            for(var key in homeworks) {
                if(!homeworks.hasOwnProperty(key)) {
                   continue;
                } else if (homeworks[key].id == this.props.homeworkID) {
                    this.setState({homework:homeworks[key], hasLoaded:true})
                    break;
                }
            }
        });
        
        AssignmentService.getHomeworkFeatures(this.props.homeworkID).then(function(response){
            var ScoresVariable = ScoresAndReports;
            ScoresVariable.name = function() {return Translation.get(12109 , 'Results')};
            this.steps.push(ScoresVariable);

            for(var idx = 0; idx < response.length; idx++){

                var feature = response[idx];
                switch(String(feature.uid))
                {
                    
                    case "1" : this.steps = this.steps.concat([VocabPanel]); break;
                    case "2" : this.steps = this.steps.concat([SentencePanel]); break;
                    case "3" : this.steps = this.steps.concat([VerbPanel]); break;
                    case "4" : this.steps = this.steps.concat([GrammarPanel]); break;
                    case "5" : 
                            this.steps = this.steps.concat([ExamPanel]);
                            ScoresVariable.name = function() {return Translation.get(12256 , 'Results and grading')};
                            break;
                    case "6" : this.steps = this.steps.concat([CustomPanel]); break;
                    
                }
            }


            

            this.setState({
                features:response
            });

        }.bind(this));
    }

    getBadge(){

        if(this.state.homework.completed == true) return <Badge>{Translation.get('772' , 'Terminé')}</Badge>
        
        if((new DateFormat()).getDate(this.state.homework.due) >= (new Date().getTime()))
        {
            return <Badge>{Translation.get('12166', 'En cours')}</Badge>
        }


        return <Badge>{Translation.get(774, 'Overdue')}</Badge>
    }

    renderBar(){

        let features = this.state.features.map(function(feature){
            return <li>{feature.name}</li>
        });

        var onEdit = function(){

            window.location.href = "#/assign/duplicate/" + this.props.homeworkID;

        }.bind(this);

        var deleteHomework = function(){
            this.setState({showDeleted:true});
        };


        var onArchivedHomework = function(){
            this.setState({showArchived:true});
        };


        return <div>
                    <div className="p-20 p-b-0">
                        <h4>
                            {this.state.homework.name}
                        </h4>
                        <small>
                            {Translation.get(12104, 'Due Date')}&nbsp;:&nbsp;{(new DateFormat()).format(this.state.homework.due)}</small>
                        <div className="p-t-10">
                            {this.getBadge()}
                        </div>
                    </div>
                    <div className="p-r-20 p-l-20 p-t-10 p-b-0">
                        <TaskNames tasks={this.state.homework.tasks} />
                    </div>
                    <div className="p-r-20 p-l-20 p-t-10 p-b-0">
                        <Button onClick={onArchivedHomework.bind(this)}block>Archive Homework</Button>
                        <Button onClick={deleteHomework.bind(this)} block>Delete Homework</Button>
                        <Button onClick={onEdit.bind(this)} block>Edit Homework</Button>
                    </div>
               </div>
    }


    deleteObject(){
        AssignmentService.setDeleted(this.props.homeworkID , "1").then(function(){
            window.history.back();
        }.bind(this))
    }

    archiveObject(){
        AssignmentService.setArchived(this.props.homeworkID , "1").then(function(){
            window.history.back();
        }.bind(this))
    }


    closeDeleted(){
        this.setState({showDeleted:false});
    }

    closeArchived(){
        this.setState({showArchived:false});
    }

    getPopupModals() {
        return [<Comfirmation body={Translation.get(12600 , 'Are you sure you wish to delete this assignment')} onSave={this.deleteObject.bind(this)} show={this.state.showDeleted} onHide={this.closeDeleted.bind(this)}/> ,<Comfirmation body={Translation.get(12758 , 'Are you sure you wish to archive this assignment?')} onSave={this.archiveObject.bind(this)} show={this.state.showArchived} onHide={this.closeArchived.bind(this)}/>];
    }

    render(){

        if (this.state.hasLoaded == false) {
            return <ProgressBar animated progress={45}/>;
        }

        return (<div>
            {this.getPopupModals()}
            <Row>
                <Col sm={12} md={12}>
                            <Row>
                                <Col md={8}><Card.Title><span>
                                    </span>&nbsp;{Translation.get(2008 , 'Assignment Name')}: {this.state.homework.name}<br/>
                                    &nbsp;<small>{Translation.get(12601 , 'Dates')}: <small>{(new Date(this.state.homework.set.replace(" ", "T")).format('d-m-Y'))}</small>&nbsp;-&nbsp;<small>{(new Date(this.state.homework.due.replace(" ", "T")).format('d-m-Y'))}</small></small></Card.Title></Col>
                                <br/>
                            </Row>

                    <Profile edit={this.state.homework.edit} id={this.props.homeworkID} archive={()=>{this.setState({showArchived:true})}} delete={()=>{this.setState({showDeleted:true})}} data={{homework:this.state.homework , homeworkID:this.props.homeworkID}}
                                 panels={ this.steps}/>
                    </Col>
            </Row>
                </div>);
    }
}